export default __webpack_public_path__ + "static/media/womp-womp.358c9159.gif";